<mat-form-field class="example-full-width" style="width: 100%">
    <mat-icon style="margin-top: 10px;">admin_panel_settings</mat-icon>
    <input style="font-size: 22px; margin-left: 28px; color: black;  height: 49px; margin-top: -34px;" matInput disabled
        value="Role Security">
</mat-form-field>